export default __webpack_public_path__ + "static/media/medium.e82bb572.jpg";